import axios from 'axios';

export default {
    async spaLogin(credentials) {
        await axios.get('/sanctum/csrf-cookie');
        return axios.post('api/auth/spa-login', credentials);
    },
    async spaLogout() {
        return axios.post('api/auth/spa-logout');
    },
    async getStaticData() {
        return axios.get('api/static-data');
    },
    async spaFcmUpdate(token) {
        await axios.post('api/fcmtokens', { fcmtoken: token });
    }
};
